export enum ErrorType {
  NETWORK = 'NETWORK',
  NOTIFICATION = 'NOTIFICATION',
  DATA = 'DATA'
}

export interface ErrorInformation {
  type: ErrorType;
  message: string;
}
